// document.querySelectorAll(".accordion-item-header").forEach(e=>{e.addEventListener("click",()=>{let t=e.parentElement,o=t.querySelector(".accordion-item-body");t.classList.toggle("active"),t.classList.contains("active")?o.style.maxHeight=o.scrollHeight+"px":o.style.maxHeight=null})});var anchors=document.querySelectorAll("a.cstm-varient");for(const anchor of anchors)anchor.classList.contains("white")&&window.location.href.includes("white")?anchor.classList.add("active"):anchor.classList.contains("black")&&window.location.href.includes("black")&&anchor.classList.add("active");let mainContent=document.getElementById("MainContent"),smoothWrapper=document.createElement("div");smoothWrapper.id="smooth-wrapper";let smoothContent=document.createElement("div");for(smoothContent.id="smooth-content";mainContent.firstChild;)smoothContent.appendChild(mainContent.firstChild);smoothWrapper.appendChild(smoothContent),mainContent.appendChild(smoothWrapper),ScrollTrigger.isTouch||ScrollSmoother.create({wrapper:"#smooth-wrapper",smoother:"#smooth-content",smooth:1.5,effects:!0,invalidateOnRefresh:!0}),$(document).on("click","[custom-menu-close]",function(){$(".menu-drawer-container summary").trigger("click")});const menuDetails=document.querySelector(".menu-drawer-container");menuDetails&&menuDetails.addEventListener("toggle",()=>{menuDetails.open?(document.body.style.overflow="hidden",document.body.style.position="fixed",document.body.style.width="100%"):(document.body.style.overflow="",document.body.style.position="",document.body.style.width="")});




document.querySelectorAll(".accordion-item-header").forEach((e) => {
  e.addEventListener("click", () => {
    let t = e.parentElement,
      o = t.querySelector(".accordion-item-body");
    t.classList.toggle("active"), t.classList.contains("active") ? (o.style.maxHeight = o.scrollHeight + "px") : (o.style.maxHeight = null);
  });
});

var anchors = document.querySelectorAll("a.cstm-varient");
for (const anchor of anchors)

  anchor.classList.contains("white") && window.location.href.includes("white")
  ? anchor.classList.add("active")
  : anchor.classList.contains("black") && window.location.href.includes("black")
  ? anchor.classList.add("active")
  : anchor.classList.contains("sage") && window.location.href.includes("sage") &&
    anchor.classList.add("active");

// let mainContent = document.getElementById("MainContent"),
//   smoothWrapper = document.createElement("div");
// smoothWrapper.id = "smooth-wrapper";
// let smoothContent = document.createElement("div");
// for (smoothContent.id = "smooth-content"; mainContent.firstChild; ) smoothContent.appendChild(mainContent.firstChild);
// smoothWrapper.appendChild(smoothContent),
//   mainContent.appendChild(smoothWrapper),
//   ScrollTrigger.isTouch || ScrollSmoother.create({ wrapper: "#smooth-wrapper", smoother: "#smooth-content", smooth: 1.5, effects: !0, invalidateOnRefresh: !0 }),

// const menuDetails = document.querySelector(".menu-drawer-container");
// menuDetails &&
//   menuDetails.addEventListener("toggle", () => {
//     menuDetails.open
//       ? ((document.body.style.overflow = "hidden"), (document.body.style.position = "fixed"), (document.body.style.width = "100%"))
//       : ((document.body.style.overflow = ""), (document.body.style.position = ""), (document.body.style.width = ""));
//   });


  $(document).on("click", "[custom-menu-close]", function () {
    $(".menu-drawer-container summary").trigger("click");
  });

/* STICKY Announcement Bar */

window.addEventListener('scroll', function() {
    if (window.scrollY > 0) {
        document.body.classList.add('scrolled');
    } else {
        document.body.classList.remove('scrolled');
    }
});